/**
 * BJT 模拟题库 — 完整版
 * 共 20 题，覆盖 Knowledge_Nodes.txt 全部一级知识板块
 *
 * 字段说明：
 *   type        : 'grammar'（语法）| 'vocab'（词汇）| 'expression'（表现力问题）
 *   difficulty  : 'J1+' | 'J1' | 'J2' | 'J3'
 *   section     : 'reading'（読解）| 'listening'（聴解）| 'listeningReading'（聴読解）
 *   answer      : 0=A, 1=B, 2=C, 3=D
 */

// ─────────────────────────────────────────
// 板块一：高级敬语体系  Q1~Q3
// ─────────────────────────────────────────

const Q1 = {
  id: 1,
  number: '1番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：尊他语特殊动词 なさる',
  scene: '秘书向来访客人说明上司当前状态',
  lines: [
    'ただいま田中部長は応接室でお客様と打ち合わせを（　　）ております。',
    '終わり次第こちらにご連絡いたします。',
  ],
  options: ['されて', 'なさっ', 'いたし', 'おられ'],
  answer: 1,
  explanation:
    '上司（田中部長）的行为应使用尊他语。「なさる」是「する」的特殊尊他动词，连用形「なさっ」接「ております」构成「なさっております」，是最规范的商务表达。A「されて」语气不够正式；C「いたし」是自谦语，用于描述自己的行为，此处错误；D「おられ」是存在动词，语义不符。',
};

const Q2 = {
  id: 2,
  number: '2番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：自谦语特殊动词 伺う vs 参る',
  scene: '营业担当者向取引先说明下次拜访计划',
  lines: [
    '来週の水曜日午後に、担当の鈴木が貴社に（　　）予定でございます。',
    'ご都合いかがでしょうか。',
  ],
  options: ['伺う', '参る', 'おいでになる', 'いらっしゃる'],
  answer: 0,
  explanation:
    '「伺う」兼有"拜访（对方处所）"和"询问"之意，是最适合「貴社に」（前往对方公司）语境的自谦动词。「参る」也是自谦语，但泛指移动，不强调"拜访"含义。C「おいでになる」和D「いらっしゃる」均为尊他语，用于描述对方行为，不能用于自己公司员工（鈴木）。',
};

const Q3 = {
  id: 3,
  number: '3番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：礼貌拒绝 ～いたしかねます',
  scene: '供应商担当者向取引先说明本周无法对应追加订单',
  lines: [
    '誠に恐れ入りますが、今週中の納品については、',
    '現在の生産体制では対応（　　）。',
    '来週月曜日であれば、ご用意できます。',
  ],
  options: ['できません', 'いたしかねます', 'されません', 'できないです'],
  answer: 1,
  explanation:
    '「いたしかねます」由自谦语「いたす」+表示困难的「かねる」构成，是商务场合委婉表达"无法做到"的最高礼貌形式，隐含"非常抱歉但实在做不到"的歉意。A「できません」虽语法正确但过于直接；C「されません」形式错误；D「できないです」是口语，不适合对外正式场合。',
};

// ─────────────────────────────────────────
// 板块二：商务功能句型  Q4~Q8
// ─────────────────────────────────────────

const Q4 = {
  id: 4,
  number: '4番',
  type: 'grammar',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '商务功能句型：转折让步 ～ものの',
  scene: '营业部门负责人在季度总结报告中说明结果',
  lines: [
    '今期は積極的な販促活動を展開した（　　）、',
    '売上目標には届きませんでした。',
    '来期に向け、戦略の見直しが必要です。',
  ],
  options: ['ものの', 'にもかかわらず', 'ながらも', 'とはいえ'],
  answer: 0,
  explanation:
    '「ものの」接在动词た形后，表达"虽然做了……但结果不如预期"，带有客观反省语气，最适合此类总结报告。「にもかかわらず」语气更强，暗含"不顾……仍然"的怨嗟感，不适合平静报告文体。「ながらも」通常接形容词或名词。「とはいえ」表示承认前述事实后的让步，逻辑关系有所不同。',
};

const Q5 = {
  id: 5,
  number: '5番',
  type: 'grammar',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '商务功能句型：被迫义务 ～ざるを得ない',
  scene: '管理层在内部战略会议上讨论成本压缩对策',
  lines: [
    '市場環境の悪化を踏まえ、今期は大幅なコスト圧縮を実施（　　）。',
    '取締役会でもその旨を確認しております。',
  ],
  options: ['するべきです', 'せざるを得ません', 'しなければなりません', 'するものです'],
  answer: 1,
  explanation:
    '「せざるを得ない」（「せず」古语形「ざる」+「得ない」）表示"迫于外部形势不得不做"，含无奈被迫的语气，完美契合"市場環境の悪化"这一外部压力背景。A「するべきです」是主动建议；C「しなければなりません」表义务但缺少被迫语气；D「するものです」是常识性判断，均不如B准确。',
};

const Q6 = {
  id: 6,
  number: '6番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：客观推测 ～と考えられます',
  scene: '市场调查报告中对消费者趋势的分析结论',
  lines: [
    '今年度の調査結果から、若年層のオンラインショッピング利用率は',
    '来年度もさらに増加する（　　）。',
  ],
  options: ['に違いありません', 'と考えられます', 'とのことです', 'に決まっています'],
  answer: 1,
  explanation:
    '「と考えられます」是根据数据进行客观推测的标准报告用语，语气谨慎客观，体现"分析得出的合理结论"而非个人断言，最适合正式报告文体。「に違いありません」是主观强烈确信，在报告中显得武断；「とのことです」是转述他人话语的传闻表达；「に決まっています」是口语化确信，均不适合正式报告。',
};

const Q7 = {
  id: 7,
  number: '7番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：时机转折 ～を契機に',
  scene: '公司CEO在组织变革发布会上说明战略意图',
  lines: [
    '今回の組織改編（　　）、グローバル事業部を新設し、',
    '海外市場への本格参入を目指してまいります。',
  ],
  options: ['を契機に', 'に先立ち', 'に伴い', 'を前にして'],
  answer: 0,
  explanation:
    '「を契機に」强调以某事件为起点和跳板，开启全新行动方向，最符合"以组织改编为契机推进海外战略"的积极启动语气。「に先立ち」表示"在某事之前"，时间顺序相反；「に伴い」表示随某事同步发生，弱化主动性；「を前にして」表示面临即将发生的事，带紧张感，语境不符。',
};

const Q8 = {
  id: 8,
  number: '8番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：部分否定 必ずしも～ない',
  scene: '高管在内部会议上对下属方案委婉提出保留意见',
  lines: [
    'ご提案の内容は理解しましたが、この案が（　　）最適解とは言えず、',
    'さらなる検討が必要かと存じます。',
  ],
  options: ['少しも', '必ずしも', 'まったく', '全然'],
  answer: 1,
  explanation:
    '「必ずしも～ない」是部分否定，意为"并非一定/未必"，在承认方案有一定合理性的同时表达保留意见，是商务场合委婉提出异议的标准句式，避免全盘否定显得过于强硬。A「少しも」、C「まったく」、D「全然」均为全面否定，语气过强，与接续助词「～とは言えず」的让步语气不协调。',
};

// ─────────────────────────────────────────
// 板块三：词汇辨析  Q9~Q13
// ─────────────────────────────────────────

const Q9 = {
  id: 9,
  number: '9番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析：应对类 対応する vs 対処する',
  scene: '客服部门收到重大投诉后，部长在内部会议上说明处理方针',
  lines: [
    'お客様からの苦情に対し、まず担当者が速やかに（　　）することが最優先です。',
    'その後、原因分析と再発防止策を講じます。',
  ],
  options: ['対応', '対処', '応じる', '対抗'],
  answer: 0,
  explanation:
    '「対応する」侧重"接受并回应对方的需求/联系"，在客诉处理中指第一时间联系顾客、接受投诉的初步行动，强调与对方的互动关系。「対処する」更偏向"针对具体问题采取处置措施"，适合描述原因分析后的改善阶段。「応じる」表示配合/答应，语义范围不同。「対抗する」含对抗意味，完全不合语境。',
};

const Q10 = {
  id: 10,
  number: '10番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析：重要类 重要な vs 重大な',
  scene: 'IT部门在危机处理报告中描述系统事故的严重性',
  lines: [
    '本日発生したシステム障害は、顧客データの漏洩リスクを伴う（　　）な問題であり、',
    '早急な対応が求められます。',
  ],
  options: ['重要', '重大', '主要', '肝心'],
  answer: 1,
  explanation:
    '「重大」用于描述后果严峻、影响广泛的问题，强调"严重程度"和潜在危险性，适合数据泄露等危机场景。「重要」表示"重要性高、不可忽视"，但不含危险性；「主要」意为"主要的、核心的"，用于多项目排序；「肝心」是口语化表达（"关键所在"），不适合正式危机报告。',
};

const Q11 = {
  id: 11,
  number: '11番',
  type: 'vocab',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '词汇辨析：行动类 検討する vs 考慮する',
  scene: '采购委员会讨论是否引入新供应商，负责人说明决策流程',
  lines: [
    '価格面での優位性は認めますが、品質とアフターサービスも含めて',
    '総合的に（　　）した上で、最終判断をいたします。',
  ],
  options: ['検討', '考慮', '計画', '審議'],
  answer: 0,
  explanation:
    '「検討する」表示从多方面深入研究讨论以得出结论，强调"综合评估"的研究过程，「総合的に検討する」是固定的商务决策表达。「考慮する」侧重"将某因素纳入考虑范围"，偏向因素取舍而非综合研究；「計画する」是制定计划，语义阶段不同；「審議する」多用于正式机构的正式审议，语域过高。',
};

const Q12 = {
  id: 12,
  number: '12番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '四字熟语：試行錯誤 vs 順風満帆 vs 言語道断',
  scene: '产品开发总监在项目复盘会上总结开发历程',
  lines: [
    'このプロジェクトでは（　　）を繰り返しながらも、',
    '最終的には市場ニーズに応える製品を完成させることができました。',
  ],
  options: ['順風満帆', '試行錯誤', '言語道断', '自画自賛'],
  answer: 1,
  explanation:
    '「試行錯誤」（试错/反复摸索）表示反复尝试、从失败中积累经验，最符合"历经艰辛摸索最终成功"的复盘语境，且「試行錯誤を繰り返す」是固定搭配。「順風満帆」意为一帆风顺，与"反复摸索"矛盾；「言語道断」是强烈批判用语；「自画自賛」意为自我吹捧，均与语境不符。',
};

const Q13 = {
  id: 13,
  number: '13番',
  type: 'vocab',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: '语体转换：和语词 vs 汉语词的正式度差异',
  scene: '秘书将内部工作备忘录改写为对外正式通知',
  lines: [
    '社内メモの「明日の朝から新システムを始める」を',
    '対外向け正式通知に書き換える場合、最も適切なものはどれか。',
  ],
  options: [
    '明日の朝より新システムを始めます',
    '明朝より新システムの運用を開始いたします',
    '明日の朝から新システムをやります',
    '翌朝に新システムが始まります',
  ],
  answer: 1,
  explanation:
    '对外正式文书需要三重转换：①和语词→汉语词（「始める」→「開始する」）；②时间表达正式化（「明日の朝より」→「明朝より」，「より」比「から」更正式）；③动词谦逊化（「します」→「いたします」）。A保留了和语词「始める」，缺乏自谦语；C「やります」是口语；D「始まります」是自动词（表示自然开始），与主动启动语义不符。',
};

// ─────────────────────────────────────────
// 板块四：口头表现力  Q14~Q15（聴解）
// ─────────────────────────────────────────

const Q14 = {
  id: 14,
  number: '1番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listening',
  knowledgePoint: '社会语用：建前与本音 ～検討いたしますの深层意图',
  scene: '营业团队向潜在客户提案后，等待对方答复',
  lines: [
    'A社営業：ご提案の内容はいかがでしたでしょうか。',
    'B社担当：大変興味深い内容でした。社内で検討いたします。改めてご連絡いたします。',
    '',
    'B社担当の「検討いたします」の意図として、最も可能性が高いものはどれか。',
  ],
  options: [
    '積極的に採用を進める意向を示している',
    '丁重に断る可能性が高い',
    '担当者が上司への確認を必要としている',
    '競合他社と条件を比較したい意向を示している',
  ],
  answer: 1,
  explanation:
    '「検討いたします」在日语商务场合常作为礼貌性婉拒的固定表达（"建前"），并不意味着真会认真讨论。结合「また改めてご連絡いたします」（不给出明确时间的模糊回应），真实意图（"本音"）很可能是婉拒。若对方真有兴趣，通常会追问具体细节或约定下次会议时间。A是对字面的误读；C和D虽有可能，但概率最低。',
};

const Q15 = {
  id: 15,
  number: '2番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listening',
  knowledgePoint: '社会语用：模糊表达委婉拒绝 少々難しい',
  scene: '供应商担当者面对取引先追加订单要求时的回应',
  lines: [
    '取引先：今月末までに追加で500個の発注をお願いしたいのですが。',
    '自社担当：申し訳ございません。現在の生産ラインの状況を考えますと、',
    '今月末までのご対応は（　　）でございます。',
    '来月中旬以降でしたら、ご用意できますが、いかがでしょうか。',
  ],
  options: ['なかなか難しい', '少々難しい', '到底無理', 'いたしかねる'],
  answer: 1,
  explanation:
    '「少々難しい」是商务委婉拒绝的最高礼貌形式：「少々」体现谦逊与歉意，「難しい」回避直接否定保留协商空间，后接替代方案进一步体现诚意。「なかなか難しい」稍显口语化，语气略强。「到底無理」是口语化直接拒绝，毫无商务礼貌感。「いたしかねる」比「難しい」更明确地表达"无法做到"，反而减少了协商余地——"難しい"的模糊性在此正是优点。',
};

// ─────────────────────────────────────────
// 板块五：书面与沟通策略  Q16~Q20（聴読解）
// ─────────────────────────────────────────

const Q16 = {
  id: 16,
  number: '1番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '口头会话策略：会议推进议程的标准表达',
  scene: '部门会议主持人在第一议题讨论结束后推进下一议题',
  lines: [
    '司会：それでは、第一議題についてはご意見が出そろったようですので、（　　）。',
  ],
  options: [
    '次の話題に変わりましょう',
    '次の議題に移らせていただきます',
    '別の話をしましょうか',
    '次の問題を話し合いましょう',
  ],
  answer: 1,
  explanation:
    '「次の議題に移らせていただきます」是会议推进的标准敬语表达：「議題」比「話題/話/問題」更规范；「移らせていただく」（自谦形式）体现主持人礼貌，有"承蒙各位允许进入下一议题"的含义。A「変わりましょう」过于随意；C「別の話をしましょうか」不是会议用语；D「問題」有"有待解决的负面问题"含义，在议程语境中不专业。',
};

const Q17 = {
  id: 17,
  number: '2番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '口头会话策略：表示遗憾 誠に残念ではございますが',
  scene: '负责人向对方传达己方无法出席重要活动的消息',
  lines: [
    'この度は御社の創立記念式典にお招きいただきまして誠にありがとうございます。',
    '誠に（　　）ではございますが、当日は先約がございまして、',
    'ご出席がかないません。',
  ],
  options: ['恐れ入り', '残念', '申し訳なく', '心苦しく'],
  answer: 1,
  explanation:
    '「誠に残念ではございますが」是表达"对无法参加感到遗憾"的标准商务表达，「残念」配合「誠に」的加重语气和「ではございますが」的转折结构，礼貌地传达感谢→遗憾→无法出席的三层信息。「恐れ入り」用于"不好意思/感激"，搭配不自然；「申し訳なく」适合自己有过失的场合；「心苦しく」暗示道德负担过重，语气过度。',
};

const Q18 = {
  id: 18,
  number: '3番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '口头会话策略：向上司礼貌确认指示',
  scene: '下属在接受上司新指示时有疑问，需要礼貌地核实',
  lines: [
    '部下：部長、先ほどのご指示についてですが、（　　）、',
    'A社向けとB社向けの資料、両方を今週中に準備するということでよろしいでしょうか。',
  ],
  options: [
    'ちょっと確認したいんですが',
    '念のため確認させていただきたいのですが',
    '確認しますが',
    '聞いてもいいですか',
  ],
  answer: 1,
  explanation:
    '「念のため確認させていただきたいのですが」是向上司确认指示的最规范表达：「念のため」（以防万一）体现谨慎态度和对上司的尊重；「させていただきたい」是自谦语，表达请求上司允许自己确认的姿态。A「ちょっと確認したい」是口语，不适合对上司；C「確認しますが」省略礼貌成分，过于生硬；D「聞いてもいいですか」是儿语化表达，完全不适合职场场景。',
};

const Q19 = {
  id: 19,
  number: '4番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：得体接受批评 貴重なご意見ありがとうございます',
  scene: '品质主管在客户投诉后向客户表达回应',
  lines: [
    '顧客：今回の製品不具合については、非常に不満を感じています。',
    '品質担当：（　　）ご指摘の点を真摯に受け止め、早急に改善策を講じてまいります。',
  ],
  options: [
    'すみません、失礼しました。',
    '貴重なご意見ありがとうございます。確かに改善の余地がございました。',
    'そんなつもりではありませんでしたが…',
    'ご意見は参考にいたします。',
  ],
  answer: 1,
  explanation:
    '接受投诉/批评的标准三步结构：①感谢（貴重なご意見ありがとうございます）→②承认（確かに～）→③表态（改善策を講じる）。这样既不显防御性，又表达改善意愿。A「すみません」对严重投诉显得太轻描淡写；C是辩解行为，商务场合绝对禁忌；D「参考にします」语气冷淡，暗示可能不会真正改变，反而加重客户不满。',
};

const Q20 = {
  id: 20,
  number: '5番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：立场区分 当社の方針として vs 私個人として',
  scene: '价格谈判中，对方要求降价，销售代表需明确表明立场',
  lines: [
    '取引先：もう少し価格を下げていただけないでしょうか。',
    '営業：ご要望はよく承りました。ただ、価格につきましては、（　　）、',
    '現時点でのご提示額が限界となっております。',
    '上長に確認の上、改めてご回答させていただきます。',
  ],
  options: [
    '私個人としては',
    '当社の方針として',
    '私の感覚では',
    '弊社内部の話では',
  ],
  answer: 1,
  explanation:
    '涉及价格决定权时，应使用「当社の方針として」表明这是公司层面的决策，而非个人裁量。优势有二：①防止对方将压力集中在个人担当者身上；②表明立场的权威性和正式性。A「私個人としては」将问题个人化，暗示个人有弹性，对谈判不利；C「私の感覚では」主观随意；D「弊社内部の話」不当透露内部信息，不专业。',
};

// ─────────────────────────────────────────
// 板块六：敬语体系扩展  Q21~Q27（読解）
// ─────────────────────────────────────────

const Q21 = {
  id: 21,
  number: '21番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：尊他语 おっしゃる vs おっしゃっていた（引述转达）',
  scene: '部下向同事转达上司会议中的发言内容',
  lines: [
    '田中部長は会議で「来月から新プロジェクトを開始する」と（　　）ました。',
  ],
  options: ['言い', 'おっしゃい', '申し', 'いらっしゃい'],
  answer: 1,
  explanation:
    '转达上司的发言需用尊他语。「おっしゃる」是「言う」的尊他语特殊动词，连用形「おっしゃい」接「ました」构成礼貌过去式，正确表达"部长说了……"。A「言い」不含敬意；C「申し」是自谦语，用于描述自己或己方的发言，此处是描述部长的行为，使用错误；D「いらっしゃい」是「いる/来る/行く」的尊他语，与「言う」语义无关。',
};

const Q22 = {
  id: 22,
  number: '22番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：尊他语 くださる（对方给予行为）',
  scene: '担当者在感谢邮件中表达对客户提供资料的谢意',
  lines: [
    '先日は貴重な資料をお送り（　　）、誠にありがとうございました。',
  ],
  options: ['いただき', 'くださり', 'してもらい', 'なさり'],
  answer: 1,
  explanation:
    '「くださる」是「与える/してくれる」的尊他语，描述对方（客户）为我方做某事，「お送りくださり」是「お＋动词連用形＋くださる」的尊他句型，最准确地表达"蒙您惠赐资料"。A「いただき」是自谦语「いただく」，语序应为「お送りいただき」（我方承蒙您送），虽也常用但在正式感谢函中「くださり」更自然地强调对方的主动好意。C「してもらい」是普通体，不适合对客户。D「なさり」用于其他动作，搭配错误。',
};

const Q23 = {
  id: 23,
  number: '23番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：自谦语 存じる（敬体中的「知る/思う」）',
  scene: '销售代表初次联系潜在客户时的开场白邮件',
  lines: [
    '突然のご連絡、大変失礼かと（　　）ますが、',
    '弊社のサービスについてご紹介させていただきたく、ご連絡いたしました。',
  ],
  options: ['思い', '存じ', 'わかり', '考え'],
  answer: 1,
  explanation:
    '「存じる」是「思う/知る」的自谦语，用于自己的想法，在商务邮件开头表达"深知冒昧"的歉意时，「存じます」是固定表达，比「思います」礼貌度高出一档。A「思います」不含谦逊成分；C「わかります」语义为"明白"，不符合此处"深感冒昧"的语境；D「考えます」侧重主动思考，此处用于判断性认知，不如「存じます」贴切。',
};

const Q24 = {
  id: 24,
  number: '24番',
  type: 'grammar',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: '高级敬语体系：お/ご前缀的正确添加规则（和语词/汉语词区分）',
  scene: '判断以下哪个敬语前缀添加是错误的',
  lines: [
    '次の中から、敬語としての「お/ご」の使い方が誤っているものを選びなさい。',
  ],
  options: ['お時間をいただけますか', 'ご連絡ありがとうございます', 'お電話いたします', 'おコーヒーをどうぞ'],
  answer: 3,
  explanation:
    '「お/ご」的添加规则：汉语词（音読み）前加「ご」，和语词（训読み）前加「お」。「コーヒー」是外来语，原则上不添加「お/ご」前缀。「おコーヒー」虽偶见于极高档服务业，但在一般商务场合被视为过度美化，不规范。A「お時間」（时间/和语概念）、B「ご連絡」（连絡/汉语词）、C「お電話」（电话/已融入和语用法）均为正确用法。',
};

const Q25 = {
  id: 25,
  number: '25番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：させていただく的使用边界（过度自谦禁忌）',
  scene: '判断以下哪种「させていただく」的用法不当',
  lines: [
    '次の文の中から「させていただく」の使い方として不自然なものを選びなさい。',
  ],
  options: [
    '本日の会議を欠席させていただきます',
    '資料を確認させていただきました',
    '私はこれからコーヒーを飲ませていただきます',
    '来月より担当させていただくことになりました',
  ],
  answer: 2,
  explanation:
    '「させていただく」本义是请求对方允许自己做某事，因此使用时需满足：①对方有许可权，②对自己有利。「コーヒーを飲む」是纯粹的个人行为，对方并未给予"饮用许可"，此处使用「させていただく」是典型的过度自谦，在日语语感上极为不自然。A（缺席需请假获准）、B（确认资料承对方允许）、D（接受职务分配）均符合使用条件。',
};

const Q26 = {
  id: 26,
  number: '26番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：～ていただけませんでしょうか 礼貌请求最高级',
  scene: '营业担当者请求客户在截止日前确认合同内容',
  lines: [
    '大変お手数ですが、来週金曜日までにご契約内容をご確認（　　）でしょうか。',
  ],
  options: [
    'してください',
    'していただけません',
    'なさってください',
    'してもらえませんか',
  ],
  answer: 1,
  explanation:
    '礼貌请求阶梯：「～てください」<「～ていただけますか」<「～ていただけませんでしょうか」。此句空格后接「でしょうか」，因此空格中填入「していただけません」构成「～ていただけませんでしょうか」，是对外请求的最高礼貌形式，配合「大変お手数ですが」体现双重歉意。A过于直接；C「なさってください」是命令形式，即使用敬语也有强制感；D「してもらえませんか」语气不足，适合对同事而非客户。',
};

const Q27 = {
  id: 27,
  number: '27番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '高级敬语体系：尊他语 お/ご～になる 标准句型',
  scene: '接待员引导来访客人前往会议室',
  lines: [
    '田中部長はすでに会議室に（　　）なっております。',
    'こちらへどうぞ。',
  ],
  options: ['いらっしゃい', 'おいで', 'お越し', 'ご到着に'],
  answer: 0,
  explanation:
    '描述上司/客户的存在/到达状态，「いらっしゃっております」（「いらっしゃる」+「おります」构成礼貌进行时）是最自然的尊他语表达。此题语境是「お/ご～になっております」句型，空格中需填入可与「に」衔接的词。「おいでになっております」也正确但选项B省略了完整形式。从给出选项看，A「いらっしゃい」（连用形）最符合「に～なっております」句型接续逻辑，构成「いらっしゃいになっております」→在实际口语中约化为「いらっしゃいます」，是固定表达。',
};

// ─────────────────────────────────────────
// 板块七：商务句型扩展  Q28~Q36（読解）
// ─────────────────────────────────────────

const Q28 = {
  id: 28,
  number: '28番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：原因依据 ～に基づき',
  scene: '法务部门在内部通知中说明规则调整依据',
  lines: [
    '今回の就業規則の改定は、改正労働基準法（　　）行われるものです。',
    '詳細については添付資料をご確認ください。',
  ],
  options: ['によって', 'に基づき', 'のために', 'をもとにして'],
  answer: 1,
  explanation:
    '「に基づき」（基于/依据）是商务文书中引用法律、规定、数据等权威依据时的标准表达，含有"严格遵循"的正式含义。「によって」更广泛，表示手段/原因/被动，在法律文书中也可用但不如「に基づき」精准。「のために」表目的；「をもとにして」（以……为基础）较口语化，在法律条文中正式度不足。',
};

const Q29 = {
  id: 29,
  number: '29番',
  type: 'grammar',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '商务功能句型：条件限定 ～限り',
  scene: '人事部门说明特殊假期制度的适用范围',
  lines: [
    '本制度は、勤続3年以上の正社員で（　　）、申請できます。',
  ],
  options: ['ある場合は', 'ある限り', 'あれば', 'あることから'],
  answer: 1,
  explanation:
    '「～限り」表示"在……条件成立的整个范围内"，用于设定某制度或权利的适用边界，「正社員である限り」意为"只要是正社员（且持续是）就可以申请"，强调条件的持续性。「ある場合は」只是条件的一次性判断；「あれば」（条件形）只表示满足条件时，缺乏持续性语感；「あることから」表示原因推断，语义不符。',
};

const Q30 = {
  id: 30,
  number: '30番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：准备期 ～に先立ち',
  scene: '项目负责人在启动会上说明提前准备工作安排',
  lines: [
    '新システムの本稼働（　　）、今月中にすべての担当者への研修を完了させます。',
  ],
  options: ['に先立ち', 'を契機に', 'に伴い', 'と同時に'],
  answer: 0,
  explanation:
    '「に先立ち」意为"在……之前（作为前期准备）"，强调在某重要事件正式发生前需完成的准备工作，逻辑是：先完成研修 → 然后本稼働，是"前置准备"的标准表达。「を契機に」是"以……为契机（向后推进）"，时间方向相反；「に伴い」是"随着……同步发生"；「と同時に」是"与……同时"，三者均无"事前准备"含义。',
};

const Q31 = {
  id: 31,
  number: '31番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：开端 ～を皮切りに',
  scene: '公关部门在新品发布报告中介绍全国巡回展览计划',
  lines: [
    '東京（　　）、全国10都市での展示会を順次開催してまいります。',
  ],
  options: ['を中心に', 'を皮切りに', 'から始まって', 'を契機として'],
  answer: 1,
  explanation:
    '「を皮切りに」意为"以……为第一站/开端，随后依次展开"，强调序列行动的第一步，「東京を皮切りに全国展開」是公关/营销文案中极高频的固定表达。「を中心に」意为"以……为中心"，不含序列开端语义；「から始まって」是口语化说法，不适合正式发布报告；「を契機として」偏重"以某事件为转折点"，重点是质变而非巡回序列。',
};

const Q32 = {
  id: 32,
  number: '32番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：趋势 ～つつある',
  scene: '行业报告中描述市场结构变化趋势',
  lines: [
    '近年、消費者のニーズは多様化し（　　）、企業は迅速な対応を迫られています。',
  ],
  options: ['ている', 'つつある', 'ていく', 'いく一方だ'],
  answer: 1,
  explanation:
    '「～つつある」表示某变化正在持续进行中（进行时趋势），常用于报告中描述正在演变的市场/社会现象，语体较正式。「ている」只表示当前状态或动作进行，不强调进行中的变化趋势；「ていく」表示变化向未来延伸；「いく一方だ」表示单方向持续恶化/升级（如「悪化する一方だ」），含有不可逆的强烈语气，比「つつある」更极端，不符合中性描述语气。',
};

const Q33 = {
  id: 33,
  number: '33番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：目的文言体 ～べく',
  scene: '企业内部报告中说明出差的明确目的',
  lines: [
    '来月の海外視察は、現地市場の実態を直接確認する（　　）実施します。',
  ],
  options: ['ために', 'べく', 'ように', 'ことで'],
  answer: 1,
  explanation:
    '「べく」是「ために」的文言色彩替换，表示目的，在正式商务报告/企划书中使用，体现文书庄重感。「ために」是日常目的表达，在正式文书中稍显平淡；「ように」用于期待状态实现或不可意志控制的目的（如「忘れないように」）；「ことで」表示手段而非目的。在正式企划书中「べく」是提升文体档次的标志性表达。',
};

const Q34 = {
  id: 34,
  number: '34番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：可能/难易 ～かねる（不愿/不便做）',
  scene: '担当者向客户说明无法提供对方所要求的详细信息',
  lines: [
    '申し訳ございませんが、お客様の個人情報については、',
    '第三者への提供はいた（　　）。',
  ],
  options: ['しません', 'しかねます', 'しにくいです', 'しがたいです'],
  answer: 1,
  explanation:
    '「いたしかねます」（「いたす」自谦+「かねる」）是商务场合婉拒的最高礼貌表达，「かねる」含"不便/不忍/有所顾虑地无法做"之意，比直接否定更委婉，且附带歉意。「しません」直接否定；「しにくい」表示客观上困难，不含主体立场；「しがたい」也表示困难/不容易，但在正式程度上不如「かねます」，且「しがたいです」较生硬。',
};

const Q35 = {
  id: 35,
  number: '35番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：传闻转述 ～とのことだ',
  scene: '营业助手向上司转达来自客户的口头确认信息',
  lines: [
    'お客様より、来週の打ち合わせの日程は変更なし（　　）ご連絡をいただきました。',
  ],
  options: ['といいます', 'とのことで', 'と思われ', 'に違いなく'],
  answer: 1,
  explanation:
    '「とのことで」是转述他人（此处为客户）话语内容的正式表达，「とのこと」=「ということ」的书面形式，表明所说内容来自第三方，比「といいます」更庄重。「といいます」虽可表传闻，但更常用于说明名称；「と思われ」是推测，不是转述；「に違いなく」是强烈肯定的主观判断，不适合转达客户信息。',
};

const Q36 = {
  id: 36,
  number: '36番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务功能句型：双重否定强调义务 ～ないわけにはいかない',
  scene: '项目经理在进度汇报中强调某事项必须完成',
  lines: [
    '今回の案件は、クライアントとの信頼関係を守るため、',
    '期日内に成果物を提出し（　　）。',
  ],
  options: [
    'なければなりません',
    'ないわけにはいきません',
    'ざるを得ません',
    'ないといけません',
  ],
  answer: 1,
  explanation:
    '「ないわけにはいかない」是双重否定构成的强烈义务表达，逻辑为"没有理由不做→必须做"，语气比「なければならない」更强，隐含社会/道义层面的不可逃避性，特别适合"为维护信任关系而必须……"的道义性义务表达。「なければなりません」是普通义务；「ざるを得ません」强调被迫无奈；「ないといけません」是口语化义务表达，不适合正式汇报。',
};

// ─────────────────────────────────────────
// 板块八：词汇辨析扩展  Q37~Q44（読解）
// ─────────────────────────────────────────

const Q37 = {
  id: 37,
  number: '37番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析："进行"类 推進する vs 実施する vs 実行する',
  scene: '战略规划部门描述新市场战略的推进方式',
  lines: [
    '来年度より、アジア市場への進出戦略を本格的に（　　）する予定です。',
  ],
  options: ['実行', '推進', '実施', '進める'],
  answer: 1,
  explanation:
    '「推進する」（推进）含有"持续用力向前推动"的动态感，适合描述战略性、长期性的重要方向性行动。「実行する」指"实际付诸行动/执行"，侧重具体操作层面；「実施する」指"实施/执行既定计划或制度"，偏正式行政用语；「進める」（推进/向前进）是和语词，在正式战略文件中正式度不足。描述战略层面的推动，「推進する」最贴切。',
};

const Q38 = {
  id: 38,
  number: '38番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析："发生"类 発生する vs 生じる vs 勃発する',
  scene: '危机管理报告中描述此次事故的性质',
  lines: [
    '当該工場では先月、機械の誤作動により重大な事故が（　　）しました。',
  ],
  options: ['勃発', '発生', '起こり', '生じ'],
  answer: 1,
  explanation:
    '「発生する」是客观中性的正式用语，适用于各类事故、事件、问题的书面报告，是危机管理、事故报告的标准动词。「勃発する」用于战争、大规模冲突等突发性重大事件，用于工厂事故语气过重；「起こり」是「起こる」连用形，口语化；「生じる」强调"由某原因产生/引起"，常与抽象问题（误解、差异）搭配，「生じました」在此可用但稍弱于「発生」的正式感。',
};

const Q39 = {
  id: 39,
  number: '39番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析：変更 vs 修正（范围与程度之别）',
  scene: '项目负责人说明对设计方案的调整性质',
  lines: [
    '全体の構成は変えず、一部の数値に誤りがあったため（　　）を行いました。',
  ],
  options: ['変更', '修正', '改正', '訂正'],
  answer: 1,
  explanation:
    '「修正」（修改）指在保持整体不变的前提下对局部内容进行调整，「一部の数値の誤り」正是局部细节修改的典型场景。「変更」（变更）指整体性的方向/内容改变，改动程度更大；「改正」用于修订法律、规则等制度性文件；「訂正」专指更正错误信息（如更正报道、更正数据），与「修正」语义最近，但「訂正」更强调"纠正错误"而「修正」兼含改良优化。',
};

const Q40 = {
  id: 40,
  number: '40番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析："方法"类 手段 vs 手法 vs 方法（负面/中性/技术性区分）',
  scene: '伦理委员会讨论某竞争对手的市场行为',
  lines: [
    '競合他社は顧客を囲い込むために、不当な（　　）を用いていると報告されています。',
  ],
  options: ['手法', '方法', '手段', '方式'],
  answer: 2,
  explanation:
    '「手段」在语感上带有中性偏负面的色彩，「不当な手段」是固定搭配，指"不正当的手段/手法"，常见于法律、伦理表述。「手法」偏专业/技术性，多用于正面描述某种方法技巧（如「マーケティング手法」）；「方法」最中性，但「不当な方法」在固定搭配感上不如「手段」；「方式」指体系化的方式/模式，不含负面语感。',
};

const Q41 = {
  id: 41,
  number: '41番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '词汇辨析：動詞アスペクト ～ておく（预先准备）vs ～てある（结果状态）',
  scene: '会议前助手向负责人确认资料准备状态',
  lines: [
    'A：明日の会議の資料、準備できていますか？',
    'B：はい、すでに配布できるよう印刷し（　　）。',
  ],
  options: ['ています', 'てあります', 'ておきました', 'てしまいました'],
  answer: 2,
  explanation:
    '「ておく」表示为了将来的目的而预先完成某行为，「印刷しておきました」强调"提前印好以备用"，最符合"准备就绪以便配布"的目的性语境。「てある」也表示结果状态（由他动词完成后遗留的状态），「印刷してあります」亦可接受，但「ておく」的目的性语感（"特意提前做好"）在此更自然。「ています」表进行中或状态；「てしまいました」强调"（意外/不可逆地）全部做完了"，含轻微遗憾或惊讶语气。',
};

const Q42 = {
  id: 42,
  number: '42番',
  type: 'vocab',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '商务惯用搭配：決裁を仰ぐ（向上级请示批准）',
  scene: '部门负责人说明大额采购需要走审批流程',
  lines: [
    '100万円を超える購入については、必ず上長の（　　）を仰いでください。',
  ],
  options: ['許可', '指示', '決裁', '承認'],
  answer: 2,
  explanation:
    '「決裁を仰ぐ」是商务惯用搭配，意为"请示上级的最终批准权"，「決裁」专指组织层级中具有权限者的最终批准决定，是企业采购、预算、合同审批的专用术语。「許可」是一般性许可；「指示」是上级给下级的指令，方向相反；「承認」与「決裁」语义接近，但「承認を仰ぐ」不如「決裁を仰ぐ」固定，且「承認」偏向事后确认认可，「決裁」偏向事前权威批准。',
};

const Q43 = {
  id: 43,
  number: '43番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '形容词辨析：適切な vs 適当な（精准/马虎的语感差异）',
  scene: '经理批评下属提交的方案措辞不严谨',
  lines: [
    'この提案書の表現は少し曖昧です。もっと（　　）な言葉を使ってください。',
  ],
  options: ['適当', '適切', '妥当', '相当'],
  answer: 1,
  explanation:
    '「適切な」意为"恰当的、准确的、符合要求的"，是正面评价词，「適切な言葉」指精准表达。「適当な」有两面性：①书面上可指"合适的"，但②在口语/实际使用中常含"随便/马虎"的负面语感（「適当にやる」=随便对付），在此要求"更严谨"的语境下应避免使用「適当」以免歧义。「妥当な」指"妥当/合理"，偏向判断/决定的合理性；「相当な」意为"相当的（程度）"，语义不符。',
};

const Q44 = {
  id: 44,
  number: '44番',
  type: 'vocab',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '程度副词：極めて vs かなり vs やや（程度阶梯）',
  scene: '财务部门在业绩报告中描述利润下滑程度',
  lines: [
    '今期の純利益は前年比で（　　）減少しており、早急な収益改善が必要です。',
  ],
  options: ['ごく', 'やや', 'かなり', '極めて'],
  answer: 3,
  explanation:
    '程度副词阶梯（弱→强）：ごく（极小）< やや（略微）< かなり（相当）< 極めて（极度）。文中"要求早急改善"暗示情况紧急严峻，应使用最强程度「極めて」。「やや」只是轻微，不足以触发紧急对策；「かなり」是相当程度，接近但不如「極めて」严重；「ごく」用于极小程度，逻辑矛盾。在正式财务报告中，「極めて」+「減少」的搭配是表达严峻局面的固定表达。',
};

// ─────────────────────────────────────────
// 板块九：口头会话表现力扩展  Q45~Q52（聴解/聴読解）
// ─────────────────────────────────────────

const Q45 = {
  id: 45,
  number: '3番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '口头会话策略：提出异议 ごもっともですが～',
  scene: '会议中，下属需要对上司的提案提出不同意见',
  lines: [
    '上司：来月から全部門で残業を一律禁止にしましょう。',
    '部下：（　　）、現在進行中のプロジェクトに支障が出る可能性も考慮すべきではないでしょうか。',
  ],
  options: [
    'でも、それは違います',
    'ごもっともですが、一点だけ申し上げますと',
    'そうですね、賛成します',
    'おっしゃる通りで、問題ありません',
  ],
  answer: 1,
  explanation:
    '「ごもっともですが」是"您说得很有道理，但是……"的标准异议起手式，先肯定对方立场再提出保留意见，体现"先承认后异议"的日式商务礼节。A直接否定，在下级对上级场合完全不可；C和D均表示同意，无法引出异议。「ごもっもですが、一点だけ申し上げますと」是BJT高频表达，「一点だけ」将异议范围限定化，进一步降低冲突感。',
};

const Q46 = {
  id: 46,
  number: '4番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '口头会话策略：倾听回应（相槌）さようでございますか',
  scene: '客户服务代表接听客户投诉电话，需给出适当的回应',
  lines: [
    '顧客：先週届いた商品なんですが、一部が破損していたんです。',
    '担当者：（　　）。それは大変失礼いたしました。',
  ],
  options: [
    'そうですか',
    'なるほど',
    'さようでございますか',
    'わかりました',
  ],
  answer: 2,
  explanation:
    '面对客户投诉，相槌词需体现足够的礼貌和关切。「さようでございますか」是「そうですか」的最高礼貌形式，在对外电话/接待中是标准相槌，表达"原来如此"并隐含关切。A「そうですか」礼貌度不足；B「なるほど」（原来如此）是偏对等关系的相槌，对客户稍显轻慢；D「わかりました」是确认理解，不是共情性回应，且在投诉情境中略显冷漠。',
};

const Q47 = {
  id: 47,
  number: '5番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '口头会话策略：提出替代方案 もしよろしければ',
  scene: '营业代表在客户拒绝原始方案后提出替代建议',
  lines: [
    '顧客：やはり、今の予算ではこのプランは難しいですね。',
    '営業：（　　）、ご予算に合わせた別のプランもご提案できますが、いかがでしょうか。',
  ],
  options: [
    'じゃあ、',
    'もしよろしければ、',
    'それなら仕方ないので、',
    'どうしてもというなら、',
  ],
  answer: 1,
  explanation:
    '「もしよろしければ」（如您不介意的话）是提出替代方案的标准开场白，给对方充分的选择自由，体现"提议而非强迫"的商务礼仪。A「じゃあ」是口语连接词，不适合对客户；C「仕方ないので」含有无奈放弃语气，给人"勉强提供"的负面感；D「どうしてもというなら」有"迫不得已才考虑"的语气，会令客户感到不受欢迎。',
};

const Q48 = {
  id: 48,
  number: '6番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listening',
  knowledgePoint: '社会语用：結構です的双重含义（"很好"vs"不需要"）',
  scene: '接待员询问来访客人是否需要茶水',
  lines: [
    '接待：お茶をお持ちしましょうか。',
    '来客：結構です。',
    '',
    '来客の意図として、最も可能性が高い解釈はどれか。',
  ],
  options: [
    '茶を持ってきてほしい',
    '断っている',
    '返事を保留している',
    '種類を確認したい',
  ],
  answer: 1,
  explanation:
    '「結構です」在此语境中最常见的解读是"不用了/婉拒"（即「いいえ、結構です」的省略形），而非"很好/请便"。关键在于：提问是「しましょうか」（要不要），直接回答「結構です」而非「はい」或「お願いします」，遵循日语语用惯例表示婉拒。这是典型的"建前语言"考点：字面是"不错"，实际是拒绝。若要接受，日本人通常会说「はい、ぜひお願いします」。',
};

const Q49 = {
  id: 49,
  number: '2番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '口头会话策略：逻辑接续词 しかしながら（正式逆接）',
  scene: '部长在会议总结发言中表达转折',
  lines: [
    '今期の営業成績は目標を上回る結果となりました。',
    '（　　）、来期に向けてはさらなる課題が山積しており、気を抜くことはできません。',
  ],
  options: ['だから', 'しかしながら', 'そして', 'さらに'],
  answer: 1,
  explanation:
    '「しかしながら」是「しかし」的正式书面/演讲体，用于在肯定前述内容后引出转折或对比信息，适合会议总结、报告等正式场合。「だから」是口语顺接因果连词；「そして」是顺接添加；「さらに」是递进添加，三者均为顺接，无法引出"虽然成绩好、但仍有课题"的转折关系。',
};

const Q50 = {
  id: 50,
  number: '3番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '口头会话策略：总结表达 要するに（要言之）',
  scene: '负责人在漫长讨论后向全员整理核心结论',
  lines: [
    '（様々な意見が出た後）',
    '司会：皆さん、ありがとうございます。（　　）、今回の方針は予算内で最大の効果を',
    '追求するということですね。',
  ],
  options: ['つまり', '要するに', '結論から申しますと', 'すなわち'],
  answer: 1,
  explanation:
    '「要するに」（归根结底/总而言之）用于将复杂讨论归纳为核心要点，含"提炼最本质内容"的语感，在会议主持中最自然。「つまり」（也就是说）更偏向解释前文逻辑；「結論から申しますと」（结论是……）更正式，用于报告式陈述；「すなわち」（即/换言之）是文言色彩的解释性连词，多用于书面。在口头总结场景中，「要するに」最为口语化且准确。',
};

const Q51 = {
  id: 51,
  number: '4番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：省略逻辑，补全被省略的主语与意图',
  scene: '电话中上司与下属的对话，需判断省略内容',
  lines: [
    '上司：あの企画書、どうなった？',
    '部下：はい、昨日（　　）終わりました。',
    '上司：よし、じゃあ先方に送っておいて。',
    '',
    '（　　）に入る最も自然な表現はどれか。',
  ],
  options: [
    '私が書くのが',
    '仕上げまして',
    '作られて',
    '完成させていただいて',
  ],
  answer: 1,
  explanation:
    '日语商务对话中大量省略主语。「仕上げまして」（「仕上げる」连用形+「まして」）自然地表达"（我）完成了"，谦逊且简洁，符合下属向上司汇报的语感。A「私が書くのが終わりました」啰嗦且主语暴露，违反日语省略习惯；C「作られて」是被动形，暗示是别人完成的，语义偏差；D「完成させていただいて」虽礼貌但「させていただく」在此语境中略显过度（完成企划书是本职工作，非需要特别请求许可的行为）。',
};

const Q52 = {
  id: 52,
  number: '5番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：处理模糊批评 澄清而非直接解决',
  scene: '项目经理收到高层模糊的不满指令',
  lines: [
    '役員：この報告書、もう少し何とかならないか。',
    '担当者：（　　）',
  ],
  options: [
    '申し訳ございません、すぐに作り直します',
    '具体的にどの点を改善すべきとお考えでしょうか',
    '私なりに精一杯書いたつもりですが…',
    'どこが問題なんですか',
  ],
  answer: 1,
  explanation:
    '面对「もう少し何とかならないか」这类模糊批评，正确策略是先"澄清具体诉求"再行动，而不是立刻盲目重做或辩解。「具体的にどの点を改善すべきとお考えでしょうか」礼貌地邀请对方明确指出具体问题，体现专业态度和对细节的重视。A直接道歉+重做，可能方向错误；C含辩解语气，商务场合禁忌；D「どこが問題ですか」语气生硬，对上级不礼貌。',
};

// ─────────────────────────────────────────
// 板块十：商务文书  Q53~Q57（読解/聴読解）
// ─────────────────────────────────────────

const Q53 = {
  id: 53,
  number: '45番',
  type: 'expression',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务文书：邮件正文首句 平素より大変お世話になっております',
  scene: '判断以下哪个邮件开头语在对外联络邮件中最正式恰当',
  lines: [
    '初めてご連絡する取引先への、最初のビジネスメールの書き出しとして最も適切なものを選びなさい。',
  ],
  options: [
    '平素より大変お世話になっております。',
    '突然のご連絡、大変失礼いたします。',
    'こんにちは。いつもありがとうございます。',
    'はじめまして。よろしくお願いします。',
  ],
  answer: 1,
  explanation:
    '这是初次联络，尚无往来关系，因此「平素より大変お世話になっております」（平日承蒙关照）不适合——此句用于有既往往来的对象。初次联络应使用「突然のご連絡、大変失礼いたします」（冒昧突然联系，深感失礼），先致歉再介绍，是初次外部联络的标准开头。C和D过于口语化，不适合正式商务邮件。',
};

const Q54 = {
  id: 54,
  number: '46番',
  type: 'expression',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务文书：道歉邮件结构 お詫び→原因→対策→再発防止',
  scene: '因发错文件而需要撰写致歉邮件，判断邮件段落顺序',
  lines: [
    '取引先に誤ったファイルを送付してしまった場合の、お詫びメールの正しい構成を選びなさい。',
  ],
  options: [
    '①対策の説明 → ②謝罪 → ③原因 → ④再発防止の約束',
    '①謝罪 → ②原因説明 → ③対策（正しいファイルの送付） → ④再発防止の約束',
    '①再発防止の約束 → ②原因説明 → ③対策 → ④謝罪',
    '①原因説明 → ②謝罪 → ③再発防止の約束 → ④対策',
  ],
  answer: 1,
  explanation:
    '道歉邮件的标准四步骤：①謝罪（首先道歉，体现诚意）→②原因説明（如实说明经过，不推卸）→③対策（立即采取的补救，如发送正确文件）→④再発防止（承诺防止再次发生，恢复信任）。此顺序遵循"先情感后逻辑"的日式道歉文化：先安抚对方情绪，再解释原因，最后给出行动保证。',
};

const Q55 = {
  id: 55,
  number: '47番',
  type: 'expression',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '商务文书：企划书陈述背景 ～を背景に',
  scene: '企划书引言部分，说明提案的时代背景',
  lines: [
    '少子高齢化の急速な進展（　　）、介護サービス市場の拡大が見込まれます。',
    '本企画ではその需要を取り込む新サービスを提案いたします。',
  ],
  options: ['から', 'を背景に', 'によって', 'をもとに'],
  answer: 1,
  explanation:
    '「を背景に」（以……为背景）是企划书/报告书中描述宏观趋势/社会背景的标准表达，「少子高齢化を背景に」是BJT读解的超高频固定搭配。「から」是普通原因连词；「によって」表手段或原因；「をもとに」（以……为基础/根据）侧重"以某信息/数据为依据"，与描述社会背景的语感不符。',
};

const Q56 = {
  id: 56,
  number: '48番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '书面语接续：～を踏まえ（基于……考量）',
  scene: '战略提案书中引用前次会议决议作为本次行动依据',
  lines: [
    '前回の検討会でのご意見（　　）、今回の改訂版をご提案いたします。',
  ],
  options: ['にもとづいて', 'を踏まえ', 'を参考にして', 'に応じて'],
  answer: 1,
  explanation:
    '「を踏まえ」（踏まえる=以……为基础认真考量）表示充分吸收、尊重前述内容后提出新方案，含有"认真对待意见"的谦逊态度，是提案/报告书中引用上次反馈时的最高礼貌表达。「にもとづいて」（基于）更强调客观依据/规定；「を参考にして」（参考）语气较轻，暗示可以不全部采纳；「に応じて」（根据/按照）多用于对应需求/条件，语义偏差。',
};

const Q57 = {
  id: 57,
  number: '49番',
  type: 'expression',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: '商务文书：谦逊主张表达 ～させていただきたいと存じます',
  scene: '企划负责人在提案书结尾提出核心建议',
  lines: [
    '以上の分析を踏まえ、来期より新市場への参入を（　　）。',
    'ご検討のほど、何卒よろしくお願い申し上げます。',
  ],
  options: [
    '提案します',
    'ご提案いたします',
    '提案させていただきたいと存じます',
    '提案してもよいでしょうか',
  ],
  answer: 2,
  explanation:
    '「させていただきたいと存じます」融合了「させていただく」（自谦请求许可）+「たい」（意愿）+「と存じます」（「と思います」的最高敬体），是企划书/提案书中提出主张的最谦逊庄重表达，体现"请求贵方允许本人提出此建议"的姿态，在正式提案书结语中是最高规格写法。A「提案します」普通体；B礼貌但不含谦逊的请求意味；D是疑问句，不适合确定性提案。',
};

// ─────────────────────────────────────────
// 板块十一：财务贸易术语与综合应用  Q58~Q60（聴読解）
// ─────────────────────────────────────────

const Q58 = {
  id: 58,
  number: '6番',
  type: 'vocab',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '领域高频词汇：納期（交货期）的正确使用',
  scene: '生产调度与销售部门的电话沟通',
  lines: [
    '営業：B社からの追加注文の件ですが、今月末の（　　）には間に合いますか？',
    '生産：現在のラインの状況では、来月10日が限界です。',
  ],
  options: ['締め切り', '納期', '期限', '期日'],
  answer: 1,
  explanation:
    '「納期」是贸易/制造业专用术语，专指"商品的交货日期"，是「納める（交付）+期（期限）」的复合词，B to B交易中不可替换。「締め切り」是截止日期，偏向文件/申请类；「期限」是广义期限，适用范围广但不含"交货"语义；「期日」是正式场合的指定日期，如还款日，不专属于货物交付语境。「納期を守る/納期に間に合う」是贸易高频固定搭配。',
};

const Q59 = {
  id: 59,
  number: '7番',
  type: 'vocab',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '领域高频词汇：採算が合う（合算/划算）',
  scene: '采购委员会讨论新供应商报价是否合理',
  lines: [
    'A：この単価では、品質管理のコストを含めると（　　）かどうか疑問ですね。',
    'B：おっしゃる通りです。もう少し価格交渉が必要かと思います。',
  ],
  options: ['利益が出る', '採算が合う', '利潤が取れる', '割が合う'],
  answer: 1,
  explanation:
    '「採算が合う」（「採算」=盈亏核算）是商务/财务讨论中判断某方案"是否能盈利/是否划算"的固定惯用搭配，是B to B交易判断的高频术语。「利益が出る」虽意思相近但不如「採算が合う」固定规范；「利潤が取れる」语感不自然；「割が合う」（合算/划算）是口语化惯用语，在正式商务讨论中不如「採算が合う」正式。',
};

const Q60 = {
  id: 60,
  number: '8番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：対内(内部)语态 vs 対外(对外)语态的区分',
  scene: '同一信息在对内传达与对外邮件中的不同表达',
  lines: [
    '「明日の会議に山田部長も来てもらう」という内容を取引先に伝える場合、',
    '最も適切な表現はどれか。',
  ],
  options: [
    '明日の会議に山田部長も来てもらいます',
    '明日の会議に山田部長もいらっしゃいます',
    '明日の会議に山田部長も参加される予定です',
    '明日の会議に山田部長も参加いたす予定でございます',
  ],
  answer: 3,
  explanation:
    '对外语态的核心原则：①谈及自己公司的人（山田部长）时，不论其职位高低，对外均使用自谦语，降低己方人物；②对外时使用「参加いたす/参ります」而非「いらっしゃる/来てもらう」。D「参加いたす予定でございます」是「参加する」的自谦形，对取引先是最规范的表达。B「いらっしゃいます」是尊他语，不能用于描述己方人员；C「参加される」是对对方人员的尊他表达，此处不当；A是对内语体。',
};

// ─────────────────────────────────────────
// 板块十二：聴解追加  Q61~Q74
// ─────────────────────────────────────────

const Q61 = {
  id: 61,
  number: '7番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '电话接待：转接时的标准表达 少々お待ちくださいませ',
  scene: '前台接到外部电话，需要转接给担当者',
  lines: [
    '外線：田中様のご担当の山本さんはいらっしゃいますか。',
    '受付：はい、（　　）。ただいまおつなぎいたします。',
  ],
  options: ['少しお待ちください', '少々お待ちくださいませ', 'ちょっと待って', '少しお待ちになってください'],
  answer: 1,
  explanation:
    '电话转接时，「少々お待ちくださいませ」是最高礼貌的等待请求：「少々」比「少し」正式，「くださいませ」比「ください」礼貌度更高，「ませ」增添柔和恭敬感。A「少しお待ちください」礼貌但稍逊；C口语无法用于正式电话；D「お待ちになってください」语法上将对方行为尊他化，结构不自然。',
};

const Q62 = {
  id: 62,
  number: '8番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '电话礼仪：接听外线的标准开头语',
  scene: '公司员工接到外部来电',
  lines: [
    '（電話が鳴る）',
    '担当者：（　　）',
  ],
  options: [
    'はい、何でしょうか',
    'お電話ありがとうございます。株式会社A、営業部の田中でございます',
    'もしもし、田中です',
    'はい、田中ですが',
  ],
  answer: 1,
  explanation:
    '接外线的标准格式：「お電話ありがとうございます」（感谢来电）+公司名+部门名+姓名+「でございます」，一句话完成"感谢→身份确认"，让对方确认拨对了号码。A缺失身份信息；C「もしもし」是个人电话用语，商务场合不当；D缺少公司/部门信息且礼貌度不足。',
};

const Q63 = {
  id: 63,
  number: '9番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '婉拒邀请：ぜひ伺いたいのですが、あいにく～',
  scene: '同事邀请参加非正式聚会，需礼貌拒绝',
  lines: [
    '同僚：今夜、歓迎会があるんですが、一緒にどうですか？',
    '担当者：（　　）',
  ],
  options: [
    '行けません',
    'ぜひ伺いたいのですが、あいにく先約がございまして',
    'その日は無理です',
    '参加できないかもしれません',
  ],
  answer: 1,
  explanation:
    '「ぜひ伺いたいのですが、あいにく～」是婉拒邀请的标准句式：先表达意愿（「ぜひ伺いたい」），再用「あいにく」（偏偏/不凑巧）引出无法参加的理由，体现"非常遗憾但有不得已的原因"。A和C直接拒绝缺乏礼貌；D模糊不清，反而让对方产生期待。',
};

const Q64 = {
  id: 64,
  number: '10番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '表达有条件同意：～という条件であれば',
  scene: '谈判中对方提出条件，己方表示有条件接受',
  lines: [
    '取引先：納期を2週間延ばしていただけますか。',
    '自社：（　　）、今回は対応いたします。',
  ],
  options: [
    '仕方ないから',
    '今回限りという条件であれば',
    '次もお願いします',
    'どうぞ、いつでも',
  ],
  answer: 1,
  explanation:
    '「今回限りという条件であれば」在接受对方特殊请求的同时，明确划定边界（"仅此一次"），防止对方将例外固化为惯例，是谈判中保护己方利益的专业表达。A「仕方ない」语气消极，显示己方没有话语权；C和D均无条件同意，放弃了谈判筹码。',
};

const Q65 = {
  id: 65,
  number: '11番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listening',
  knowledgePoint: '社会语用：读懂沉默与话题回避',
  scene: '向上司汇报项目进度，上司对某部分没有回应',
  lines: [
    '部下：A案とB案、どちらがよいでしょうか。',
    '上司：（しばらく沈黙の後）…そうですね、もう少し考えてみましょう。',
    '',
    '上司の意図として最も適切な解釈はどれか。',
  ],
  options: [
    '両案ともに賛成している',
    '即答を避けており、どちらも問題を感じている可能性が高い',
    '部下に決定を任せたい',
    'A案を支持しているが言いにくい',
  ],
  answer: 1,
  explanation:
    '日本の職場文化では、直接批判を避けるため沉默や曖昧な返答（「もう少し考えましょう」）は否定的評価のサインであることが多い。上司が即答しないのは両案に何らかの懸念を持っているサインと読むのが最も合理的。A和D从字面解读，忽视了非言语信号；C虽有可能但不是最优先解读。',
};

const Q66 = {
  id: 66,
  number: '12番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '迟到道歉：遅れまして大変失礼いたしました',
  scene: '担当者在约定时间后5分钟到达会议室',
  lines: [
    '担当者：（入室後）（　　）。お待たせいたしました。',
  ],
  options: [
    'ごめんなさい',
    '遅れまして大変失礼いたしました',
    '遅刻してすみません',
    '少し遅れました',
  ],
  answer: 1,
  explanation:
    '「遅れまして大変失礼いたしました」是商务场合迟到道歉的标准表达，「大変」加重歉意，「失礼いたしました」是对行为本身的自谦道歉。A「ごめんなさい」是儿语；C「遅刻してすみません」口语化；D「少し遅れました」是陈述事实，不含道歉意味，失礼。',
};

const Q67 = {
  id: 67,
  number: '13番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '礼貌打听信息：差し支えなければ',
  scene: '向客户了解其公司规模以便定制提案',
  lines: [
    '営業：（　　）、御社の現在の従業員数をお聞かせいただけますか。',
  ],
  options: [
    '聞いてもいいですか',
    '差し支えなければ',
    'ちなみに',
    '知りたいんですが',
  ],
  answer: 1,
  explanation:
    '「差し支えなければ」（如果方便的话/如无不便）是询问可能涉及隐私或敏感信息时的标准前置语，给对方充分选择权，体现尊重。A和D过于直白；C「ちなみに」（顺便提一句）用于追加不重要的信息，不适合正式询问。',
};

const Q68 = {
  id: 68,
  number: '14番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '向客户介绍同事：こちらは弊社の～でございます',
  scene: '营业担当者将本公司技术人员介绍给客户',
  lines: [
    '担当者：（　　）、弊社の技術部門を担当しております鈴木でございます。',
  ],
  options: [
    'こちら、うちの鈴木です',
    'ご紹介いたします。こちらは',
    'いらっしゃいますのが',
    'お会いします、',
  ],
  answer: 1,
  explanation:
    '介绍己方人员给客户的标准句式：「ご紹介いたします。こちらは弊社の～でございます」。先用「ご紹介いたします」（恕我介绍）作引子，再以「こちらは」指示人物，以「でございます」结尾。A口语；C/D语法错误。注意：介绍己方人员时不使用尊他语（不说「こちらが鈴木さんでいらっしゃいます」）。',
};

const Q69 = {
  id: 69,
  number: '15番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listening',
  knowledgePoint: '社会语用：表扬中的批评（间接否定）',
  scene: '上司查看下属的企划书后给出反馈',
  lines: [
    '上司：よく書けていますね。ただ、数字の根拠がもう少しあると、さらに説得力が増しますね。',
    '',
    '上司が最も伝えたいことは何か。',
  ],
  options: [
    '企画書の出来が大変良い',
    '数字の根拠が不十分であり、補強が必要',
    '全体的に修正が必要',
    '担当者の努力を純粋に評価している',
  ],
  answer: 1,
  explanation:
    '「よく書けていますね」是「クッション言葉」（缓冲语），目的是软化后面的批评。「ただ、～もう少しあると」才是真正的信息核心，即"缺少数据支撑"。这是日本职场高频的"三明治批评法"：肯定→核心问题→期待改善。读懂表扬背后的批评是J1+语用能力的核心考点。',
};

const Q70 = {
  id: 70,
  number: '16番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '结束电话：失礼いたします vs それでは',
  scene: '商务电话内容确认完毕，需要礼貌挂断',
  lines: [
    '担当者：それでは、以上でよろしいでしょうか。',
    '相手：はい、よかったです。ありがとうございました。',
    '担当者：（　　）。',
  ],
  options: [
    'じゃあね',
    'こちらこそ、ありがとうございました。失礼いたします',
    'バイバイ',
    'またね',
  ],
  answer: 1,
  explanation:
    '电话结束时，「こちらこそ、ありがとうございました。失礼いたします」是标准收尾：先回礼（「こちらこそ」），再致谢，以「失礼いたします」正式告别。商务电话禁用「じゃあね」「バイバイ」等口语。「失礼いたします」在电话结束时相当于英文的"Goodbye"的正式版。',
};

const Q71 = {
  id: 71,
  number: '17番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '确认对方时间：ご都合はいかがでしょうか',
  scene: '担当者希望下周安排会面，询问对方方便的时间',
  lines: [
    '担当者：来週、一度お打ち合わせの機会をいただければと存じますが、（　　）。',
  ],
  options: [
    'いつがいいですか',
    'ご都合はいかがでしょうか',
    '時間ありますか',
    'スケジュールを教えてください',
  ],
  answer: 1,
  explanation:
    '「ご都合はいかがでしょうか」是询问对方时间是否方便的标准敬语表达，「ご都合」（您的方便/日程）是「都合」加尊他前缀，「いかがでしょうか」是「どうですか」的敬体。A和C口语不适用；D「教えてください」是命令形式，对客户不恰当。',
};

const Q72 = {
  id: 72,
  number: '18番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listening',
  knowledgePoint: '电话转接的完整流程表达',
  scene: '外线要找的担当者正在开会，需转告留言',
  lines: [
    '外線：山田さんはいらっしゃいますか。',
    '受付：ただいま山田は外出しております。（　　）',
  ],
  options: [
    '戻ったら言います',
    'よろしければ、ご伝言を承りましょうか',
    '後でかけ直してください',
    'いつ戻るかわかりません',
  ],
  answer: 1,
  explanation:
    '「よろしければ、ご伝言を承りましょうか」是担当者不在时的标准后续处理：「よろしければ」给对方选择权，「ご伝言を承る」（代为转达留言）是正式的服务性表达。A和C措辞不当，给对方添麻烦；D直接说不知道何时回来，让对方无所适从，失礼。',
};

const Q73 = {
  id: 73,
  number: '19番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listening',
  knowledgePoint: '社会语用：识别被动攻击性语言',
  scene: '会议中同事对提案的回应',
  lines: [
    '同僚A：このアプローチ、なかなか面白いですね。ただ、以前も似たような提案がありましたよね。あの時はどうなりましたっけ。',
    '',
    '同僚Aの発言に込められた意図として最も適切なものはどれか。',
  ],
  options: [
    '以前の提案に純粋に興味を持っている',
    '以前の提案が失敗した事実を持ち出し、間接的に反対意見を示している',
    'この提案を強く支持している',
    '情報収集のために質問している',
  ],
  answer: 1,
  explanation:
    '「以前も似たような提案がありましたよね。あの時はどうなりましたっけ」表面上是询问历史，实质是"暗示上次类似提案失败了，这次也可能如此"的间接否定策略。日本職場では直接否定より「過去の失敗例を引用して懸念を示す」婉曲批判が多い。这是J1+社会语用的高频考点。',
};

const Q74 = {
  id: 74,
  number: '20番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listening',
  knowledgePoint: '礼貌要求重复说明：おっしゃっていただけますか',
  scene: '电话中因线路不好没听清对方所说的电话号码',
  lines: [
    '担当者：恐れ入りますが、お電話番号を（　　）でしょうか。',
  ],
  options: [
    'もう一回言って',
    'もう一度おっしゃっていただけます',
    '繰り返してください',
    '聞こえませんでした',
  ],
  answer: 1,
  explanation:
    '「もう一度おっしゃっていただけますでしょうか」是请求对方重复的最礼貌形式：「おっしゃる」是「言う」的尊他语，「いただけますでしょうか」是请求的最高礼貌形。配合前置的「恐れ入りますが」（非常抱歉打扰），体现对对方时间的尊重。A/C直接命令；D只是告知结果，没有请求重复。',
};

// ─────────────────────────────────────────
// 板块十三：聴読解追加  Q75~Q84
// ─────────────────────────────────────────

const Q75 = {
  id: 75,
  number: '9番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '汇报演示：过渡语 次に～についてご説明いたします',
  scene: '担当者在向客户进行产品说明时，进入下一个话题',
  lines: [
    '担当者：（　　）、弊社製品の価格体系についてご説明いたします。',
  ],
  options: [
    '次は',
    '続きまして',
    'じゃあ',
    'ところで',
  ],
  answer: 1,
  explanation:
    '「続きまして」（接下来）是正式演示/汇报中推进话题的礼貌过渡语，含「続く」（连续）的文雅变形，体现演示的流畅衔接感。A「次は」口语化，用于非正式场合；C「じゃあ」完全口语；D「ところで」是话题转换词（"说到另一件事"），逻辑为引入不相关话题，此处不适用。',
};

const Q76 = {
  id: 76,
  number: '10番',
  type: 'grammar',
  difficulty: 'J1',
  section: 'listeningReading',
  knowledgePoint: '商务功能句型：假设前提 ～とすれば',
  scene: '商务谈判中，讨论对方提出的假设性条件',
  lines: [
    '先方：もし来期も同じ条件でご契約いただける（　　）、価格を5%引き下げることが可能です。',
  ],
  options: ['としたら', 'とすれば', 'であれば', 'ならば'],
  answer: 1,
  explanation:
    '「とすれば」在商务谈判中表示"如果假设……的话"，强调以某条件为前提推导出的结果，语体较正式，适合合同谈判场景。「としたら」含义相近但略口语化；「であれば」/「ならば」都是条件表达，但「とすれば」的假设性更强，适合尚未确定的条件讨论。',
};

const Q77 = {
  id: 77,
  number: '11番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listeningReading',
  knowledgePoint: '会议发言：表示保留 その点については再考の余地があるかと',
  scene: '会议中委婉表示对某提案有不同看法',
  lines: [
    '（提案が示された後）',
    '出席者：ご提案の方向性は理解しましたが、コスト面については（　　）かと存じます。',
  ],
  options: [
    '問題がある',
    '再考の余地がある',
    '違っている',
    '承認できない',
  ],
  answer: 1,
  explanation:
    '「再考の余地がある」（有重新考虑的余地）是商务会议中表示"该部分有问题，需要再想想"的最委婉表达，不直接否定，而是暗示存在改进空间。「かと存じます」进一步软化，属于"说者有意，听者须细品"的日式异议表达。A和C直接否定；D「承認できない」过于强硬。',
};

const Q78 = {
  id: 78,
  number: '12番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：解读上司的间接指令',
  scene: '上司在会议结束时的发言',
  lines: [
    '上司：（会議終了時）この案、なかなか面白いですね。山田さんはどう思いますか。',
    '',
    '上司の発言の意図として最も可能性が高いものを選びなさい。',
  ],
  options: [
    '山田さんの純粋な意見を聞きたい',
    '山田さんに追加で検討・改善するよう間接的に求めている',
    '案を即採用する意思を示している',
    '案に否定的でその理由を山田さんに説明させようとしている',
  ],
  answer: 1,
  explanation:
    '上司说「なかなか面白い」（相当有意思）表示基本认可，但紧接着问「山田さんはどう思いますか」是把球踢给担当者，暗示"你作为负责人再进一步完善吧"。这种"称赞+问你想法"的组合在日本职场是上司给下属任务的间接方式。A是字面解读，缺乏语用意识；C/D与语气不符。',
};

const Q79 = {
  id: 79,
  number: '13番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '会议主持：结束会议的正式表达',
  scene: '所有议题讨论完毕，主持人宣布会议结束',
  lines: [
    '司会：以上をもちまして、本日の会議を（　　）。ありがとうございました。',
  ],
  options: [
    '終わります',
    '終了とさせていただきます',
    '終わりにします',
    'お開きにします',
  ],
  answer: 1,
  explanation:
    '「終了とさせていただきます」（就此宣布会议结束，承蒙各位允许）是会议主持宣布结束的最正式表达，「とさせていただく」体现对参加者的礼貌感谢和许可请求意味。A/C口语；D「お開きにする」虽是正式表达，但多用于宴会/典礼的散场，商务会议更常用「終了」。',
};

const Q80 = {
  id: 80,
  number: '14番',
  type: 'vocab',
  difficulty: 'J1',
  section: 'listeningReading',
  knowledgePoint: '商务优先级词汇：喫緊の課題（最紧迫的课题）',
  scene: '管理层在年度战略会议上强调需要立即解决的问题',
  lines: [
    '今期最も（　　）のは、人材不足への対応と生産効率の改善の2点です。',
    'こちらを最優先として取り組んでいただきたい。',
  ],
  options: ['重要な課題', '喫緊の課題', '優先される事項', '中心的な問題'],
  answer: 1,
  explanation:
    '「喫緊の課題」（喫緊=极度紧迫，是文言词）是商务/政策场合描述"必须立即处理的最紧迫问题"的惯用固定表达，是BJT高级词汇高频考点。「重要な課題」只表重要性，不含紧迫性；「優先される事項」是中性的优先事项；「中心的な問題」指核心问题，不强调时间紧迫性。',
};

const Q81 = {
  id: 81,
  number: '15番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '口头汇报：表示原因根据 ～を踏まえますと',
  scene: '部门负责人在汇报时说明调整方向的根据',
  lines: [
    '先月の顧客アンケートの結果（　　）、サービス改善の方向性として3点ご提案いたします。',
  ],
  options: ['を考えると', 'を踏まえますと', 'を基準として', 'によりますと'],
  answer: 1,
  explanation:
    '「を踏まえますと」（将～充分纳入考量后）是「を踏まえて」的礼貌汇报体形式，「踏まえる」含有"以足踏实地站在某信息上"的隐喻，意为"基于充分理解该信息而……"，是提案书/汇报中引用依据的高礼貌表达。「を考えると」口语化；「によりますと」是转述传闻，不适合引用自己的调查结果。',
};

const Q82 = {
  id: 82,
  number: '16番',
  type: 'expression',
  difficulty: 'J1+',
  section: 'listeningReading',
  knowledgePoint: '社会语用：职场等级与话题引入时机',
  scene: '新人员工在会议中想要发言',
  lines: [
    '新入社員が会議中に発言したい場合、最も適切な行動はどれか。',
  ],
  options: [
    '他の人の発言が終わったら、すぐに割り込む',
    '発言の機会が回ってくるのを待つか、「よろしいでしょうか」と一言添えてから発言する',
    '黙って資料にメモを取り、後でメールで意見を伝える',
    '上司の発言の途中でも、重要なことなら遠慮なく話す',
  ],
  answer: 1,
  explanation:
    '日本職場では、特に新人が会議で発言する際は「よろしいでしょうか」と場を確認してから発言するのが礼儀。あるいは司会が発言機会を与えるのを待つ。A直接打断失礼；C放弃当场发言机会不利于参与；D打断上司是严重失礼。「よろしいでしょうか」一词体现了"请求许可进入话题"的群体意识。',
};

const Q83 = {
  id: 83,
  number: '17番',
  type: 'expression',
  difficulty: 'J2',
  section: 'listeningReading',
  knowledgePoint: '接受感谢的标准回应：おかげさまで',
  scene: '客户感谢担当者的帮助，担当者需礼貌回应',
  lines: [
    '顧客：先日はご丁寧にご説明いただき、本当にありがとうございました。',
    '担当者：（　　）、お役に立てましたようで何よりでございます。',
  ],
  options: ['とんでもないです', 'おかげさまで', 'いえいえ', 'どういたしまして'],
  answer: 1,
  explanation:
    '「おかげさまで」（托您的福）用于回应感谢时，隐含"是托您支持我们才能帮到您"的谦逊感，比「どういたしまして」（不客气）更含有日式"感恩互惠"文化感。「とんでもないです」（哪里哪里）也是谦虚回应但偏否定型；「いえいえ」太随意。「おかげさまで」+「お役に立てて何より」是接受客户感谢的最佳组合。',
};

const Q84 = {
  id: 84,
  number: '18番',
  type: 'expression',
  difficulty: 'J1',
  section: 'listeningReading',
  knowledgePoint: '社会语用：确认对方是否理解 ご理解いただけましたでしょうか',
  scene: '担当者向客户讲解复杂的合同条款后，确认理解情况',
  lines: [
    '担当者：以上が主要な契約条件となります。（　　）',
  ],
  options: [
    'わかりましたか',
    'ご不明な点はございませんでしょうか',
    '理解できましたか',
    '何かありますか',
  ],
  answer: 1,
  explanation:
    '「ご不明な点はございませんでしょうか」（是否有不明之处）是确认对方理解程度的最礼貌方式，从"对方的疑问"角度出发，而非直接问"你懂了吗"，避免让对方有被测验的感觉。A和C直接询问是否理解，带有考核感，对客户失礼；D「何かありますか」过于简短模糊。',
};

// ─────────────────────────────────────────
// 板块十四：読解追加（J3基础 + J1高级）  Q85~Q100
// ─────────────────────────────────────────

const Q85 = {
  id: 85,
  number: '50番',
  type: 'grammar',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: 'J3基础：ます形 vs て形（动作连接）',
  scene: '新员工手册中说明每日工作流程',
  lines: [
    '毎朝、まず出勤記録を（　　）、メールを確認してください。',
  ],
  options: ['入力して', '入力します', '入力した', '入力する'],
  answer: 0,
  explanation:
    '连接两个动作的先后顺序时，使用て形（「入力して」）。て形在句中表示"做完A之后再做B"的顺序关系。「入力します」是终止形，句子在此结束；「入力した」是过去式；「入力する」是辞书形，均无法承接后面的命令句。',
};

const Q86 = {
  id: 86,
  number: '51番',
  type: 'grammar',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: 'J3基础：请求表达 ～ていただけますか（基础）',
  scene: '向同事请求帮忙打印文件',
  lines: [
    'すみません、この資料を10部コピーし（　　）か。',
  ],
  options: ['てください', 'ていただけます', 'てあります', 'ておきます'],
  answer: 1,
  explanation:
    '「ていただけますか」是请求别人为自己做某事的礼貌表达（"能帮我……吗"），适合向同事、上级提出请求。「てください」是命令/请求形，礼貌度稍低；「てあります」表示结果状态；「ておきます」是预先准备，语义不符。',
};

const Q87 = {
  id: 87,
  number: '52番',
  type: 'vocab',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: 'J3基础词汇：打电话相关词汇',
  scene: '担当者外出时，同事帮忙接听电话留下留言',
  lines: [
    'A社の田中と申します。山本さんに（　　）をお願いできますか。',
  ],
  options: ['電話', '伝言', '案内', '手紙'],
  answer: 1,
  explanation:
    '「伝言をお願いする」（请求转达留言）是当担当者不在时的标准请求表达，「伝言」专指"需要转告的口信/留言"。「電話」是打电话本身；「案内」是引导/指引；「手紙」是书信，均与电话留言场景不符。「伝言をお願いできますか」是BJT J3级别的基础商务套语。',
};

const Q88 = {
  id: 88,
  number: '53番',
  type: 'grammar',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: 'J3基础：授受动词 もらう vs くれる vs あげる（方向性）',
  scene: '同事帮自己确认了一份文件',
  lines: [
    '山本さんが書類を確認し（　　）ました。',
  ],
  options: ['てくれ', 'てあげ', 'てもらい', 'ていただき'],
  answer: 0,
  explanation:
    '「てくれる」表示对方（山本さん）主动为我方做某事（主语做，我方受益），句子主语是山本さん，方向是"对方→我"，使用「てくれました」。「てあげる」是我方为对方做（方向相反）；「てもらう」/「ていただく」主语须为我方（我请/得到对方做），此处主语是山本さん，不符合语法。',
};

const Q89 = {
  id: 89,
  number: '54番',
  type: 'grammar',
  difficulty: 'J3',
  section: 'reading',
  knowledgePoint: 'J3基础：こそあど指示词的正确使用',
  scene: '担当者在邮件中引用附件内容说明',
  lines: [
    '添付の資料を確認ください。（　　）資料は先週の会議でご説明した内容です。',
  ],
  options: ['あの', 'その', 'この', 'どの'],
  answer: 2,
  explanation:
    '「こそあど」使用规则：「この」指离说话者近的事物（文中已提到的内容），「その」指离听者近或刚提到的，「あの」指双方共知的远处事物。此处「添付の資料」是说话者（写信人）刚提到的，从写信人视角是「この資料」（就是这份资料）。',
};

const Q90 = {
  id: 90,
  number: '55番',
  type: 'grammar',
  difficulty: 'J1+',
  section: 'reading',
  knowledgePoint: '高级句型：並行否定 ～はおろか～も（程度递进）',
  scene: '严峻的财务状况下，管理层说明现状',
  lines: [
    '今期は業績が低迷しており、ボーナス（　　）、基本給のカットも検討せざるを得ない状況です。',
  ],
  options: ['ばかりか', 'はおろか', 'のみならず', 'さえも'],
  answer: 1,
  explanation:
    '「はおろか」表示"别说A了，连B也……"，用于递进否定：A本来就理所当然，现在连B这种更不该发生的事也发生了。「ボーナスはおろか、基本給のカットも」= "别说奖金了，连基本工资都……"，语气最强烈，突出局面之严峻。「ばかりか」「のみならず」是"不仅……而且"的顺接递进，语气较轻；「さえも」可用但「はおろか」递进感最强。',
};

const Q91 = {
  id: 91,
  number: '56番',
  type: 'grammar',
  difficulty: 'J1+',
  section: 'reading',
  knowledgePoint: '高级句型：逆説強調 ～にもかかわらず（不顾/尽管）',
  scene: '管理层批评某部门未能完成目标',
  lines: [
    '十分なリソースを提供した（　　）、プロジェクトが遅延したことは遺憾です。',
  ],
  options: ['のに', 'にもかかわらず', 'ものの', 'くせに'],
  answer: 1,
  explanation:
    '「にもかかわらず」（尽管/不顾）在正式书面语中表示强烈的逆接，强调"明明已经……却还是……"，隐含批评或惊讶，适合正式报告/声明。「のに」也是逆接但偏口语，含说话者的抱怨感情色彩；「ものの」逆接语气较温和；「くせに」含蔑视意味，完全不适合正式场合。',
};

const Q92 = {
  id: 92,
  number: '57番',
  type: 'vocab',
  difficulty: 'J1+',
  section: 'reading',
  knowledgePoint: '高级词汇：蓋然性（可能性/盖然性）',
  scene: '法律顾问在合同风险评估报告中的措辞',
  lines: [
    '本契約における違約リスクの（　　）は低いと判断されますが、完全に排除することはできません。',
  ],
  options: ['確実性', '蓋然性', '必要性', '可能性'],
  answer: 1,
  explanation:
    '「蓋然性」（がいぜんせい）是法律/学术场合表示"某事发生的概率/可能性"的专业术语，比「可能性」更正式，常用于风险评估、法律文书。「確実性」（确定性）是"一定发生"的程度，语义不同；「必要性」是必要程度；「可能性」虽含义相近但语域不如「蓋然性」正式。',
};

const Q93 = {
  id: 93,
  number: '58番',
  type: 'grammar',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '条件句型：仮定 ～とした場合（商务分析假设）',
  scene: '财务分析报告中进行假设性预测',
  lines: [
    '売上が前年比10%増加し（　　）、営業利益は約2億円改善される見込みです。',
  ],
  options: ['ると', 'た場合', 'たとすれば', 'るなら'],
  answer: 2,
  explanation:
    '「たとすれば」（如果假设的话）是财务预测/假设性分析中的标准表达，「とすれば」强调"以此假设为前提"的分析推导，适合用于尚未发生的预测场景。「ると」表自然结果（更接近必然）；「た場合」较中性，可用但「とすれば」的假设性更明确；「るなら」是条件接受，语感不同。',
};

const Q94 = {
  id: 94,
  number: '59番',
  type: 'vocab',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '商务惯用表达：折衷案（折中方案）',
  scene: '谈判陷入僵局，调解人提出介于两方之间的方案',
  lines: [
    '双方の意見が対立したため、担当者は両者が受け入れられる（　　）を提示しました。',
  ],
  options: ['妥協案', '折衷案', '代替案', '修正案'],
  answer: 1,
  explanation:
    '「折衷案」（折衷方案）是"综合双方意见，取中间点"的方案，强调"对双方都有让步和收获的平衡点"。「妥協案」（妥协方案）偏向"为了达成一致而各退一步"，含有让步的负面感；「代替案」是替代方案（用B代替A）；「修正案」是修改后的方案，均不如「折衷案」准确表达"居中调和"之意。',
};

const Q95 = {
  id: 95,
  number: '60番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '让步句型：～とはいえ（虽说如此但）',
  scene: '年度报告中承认成绩的同时指出不足',
  lines: [
    '目標を達成できた（　　）、市場全体の成長率と比較すると依然として改善の余地があります。',
  ],
  options: ['からといって', 'とはいえ', 'ものの', 'だけに'],
  answer: 1,
  explanation:
    '「とはいえ」（虽说如此但）承认前述事实，但紧接引出修正或对比视角，语感是"尽管承认A，但从B角度看仍有问题"，适合年度报告等客观评析文体。「からといって」（不能因为……就……）是否定以A为理由的表达；「ものの」语义相近但更偏"虽然做了却未达效果"；「だけに」表示"正因为……所以更……"，是顺接强调。',
};

const Q96 = {
  id: 96,
  number: '61番',
  type: 'grammar',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '让步逆接：～ながらも（一边……一边/虽然……但）',
  scene: '企业公告中说明在困难环境下的坚持',
  lines: [
    '厳しい経営環境が続く（　　）、社員一丸となってこの難局を乗り越えてまいります。',
  ],
  options: ['にもかかわらず', 'ながらも', 'のに', 'くせに'],
  answer: 1,
  explanation:
    '「ながらも」接在名词/形容词/形容动词词干后，表示"在某状态持续的同时"的并存逆接，强调"尽管处于困难中但仍然……"的坚持精神，适合激励性声明。「にもかかわらず」语气更强烈，偏批判/惊讶；「のに」是口语，含抱怨感；「くせに」贬义，完全不适合。',
};

const Q97 = {
  id: 97,
  number: '62番',
  type: 'vocab',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '财务词汇：損益分岐点（盈亏平衡点）',
  scene: '财务部门在新项目评估报告中分析成本结构',
  lines: [
    'このプロジェクトの（　　）は月間販売数2,000個と試算されており、それ以上で黒字となります。',
  ],
  options: ['黒字化時点', '損益分岐点', '収益化目標', '採算ライン'],
  answer: 1,
  explanation:
    '「損益分岐点」（そんえきぶんきてん，Break-even Point）是财务/会计的核心术语，指收支刚好平衡、利润为零的那个销量/收入点，是"超过此点=盈利，低于此点=亏损"的临界值。这是BJT J1级财务词汇高频考点，必须掌握。其他选项均非标准财务术语。',
};

const Q98 = {
  id: 98,
  number: '63番',
  type: 'grammar',
  difficulty: 'J1+',
  section: 'reading',
  knowledgePoint: '高级强调句型：～に至っては（更不用说/甚至连）',
  scene: '批评报告中描述最严峻的部门状况',
  lines: [
    '他部門の業績も振るわなかったが、第三営業部（　　）、目標の半分にも達しなかった。',
  ],
  options: ['については', 'に至っては', 'においては', 'に関しては'],
  answer: 1,
  explanation:
    '「に至っては」（更不用说/甚至连……）是极端事例的提示表达，用于举出情况最严峻的极端案例，含"其中尤以……为甚"的强调语气。是「においては」/「については」的强化版，适合批评性报告中点出最严重的案例。「においては」/「については」/「に関しては」均为中性话题引入，缺乏极端强调感。',
};

const Q99 = {
  id: 99,
  number: '64番',
  type: 'expression',
  difficulty: 'J2',
  section: 'reading',
  knowledgePoint: '谈判语言：维持立场的礼貌表达 ご意向は十分承りましたが',
  scene: '价格谈判中对方坚持要求更大折扣，己方维持立场',
  lines: [
    '取引先：もう少し価格を下げていただかないと、今後の取引継続が難しいですね。',
    '自社：（　　）、価格の変更は現状では難しい状況でございます。',
  ],
  options: [
    'ごもっともですが',
    'ご意向は十分承りましたが',
    'おっしゃることはわかりますが',
    'そう言われても',
  ],
  answer: 1,
  explanation:
    '「ご意向は十分承りましたが」（您的意向我们已充分了解，但……）是谈判中接收对方立场后维持己方底线的最专业表达：「承りました」体现充分倾听和尊重，但「が」引出的转折传达"即便如此也无法妥协"的坚定立场。A偏向"您有道理"，暗示己方可能让步；C口语化；D「そう言われても」语气生硬，缺乏礼貌。',
};

const Q100 = {
  id: 100,
  number: '65番',
  type: 'grammar',
  difficulty: 'J1',
  section: 'reading',
  knowledgePoint: '商务功能句型：渐进表达 ～にしたがって（随着）',
  scene: '战略报告中描述随时间推进的变化',
  lines: [
    'デジタル化が進む（　　）、従来型の営業手法は見直しを迫られています。',
  ],
  options: ['につれて', 'にしたがって', 'に伴って', 'とともに'],
  answer: 1,
  explanation:
    '「にしたがって」（随着……顺势）强调随某变化"按照其轨迹/方向自然发展"，含有"顺应趋势"的语感，适合描述技术/社会趋势驱动的变化。「につれて」也表"随着"但更强调两件事同步变化；「に伴って」强调伴随性（A发生的同时B也发生）；「とともに」是最中性的"随着/与……一起"。四者语义接近，但在描述趋势迫使传统方法更新时，「にしたがって」的顺应感最贴切。',
};

// ─────────────────────────────────────────
// 导出：按考试板块分组
// ─────────────────────────────────────────

export const questionBank = {
  reading: [
    Q1, Q2, Q3, Q4, Q5, Q6, Q7, Q8, Q9, Q10,
    Q11, Q12, Q13, Q21, Q22, Q23, Q24, Q25, Q26, Q27,
    Q28, Q29, Q30, Q31, Q32, Q33, Q34, Q35, Q36, Q37,
    Q38, Q39, Q40, Q41, Q42, Q43, Q44, Q53, Q54, Q55,
    Q56, Q57, Q85, Q86, Q87, Q88, Q89, Q90, Q91, Q92,
    Q93, Q94, Q95, Q96, Q97, Q98, Q99, Q100,
  ],
  listening: [Q14, Q15, Q45, Q46, Q47, Q48, Q61, Q62, Q63, Q64, Q65, Q66, Q67, Q68, Q69, Q70, Q71, Q72, Q73, Q74],
  listeningReading: [Q16, Q17, Q18, Q19, Q20, Q49, Q50, Q51, Q52, Q58, Q59, Q60, Q75, Q76, Q77, Q78, Q79, Q80, Q81, Q82, Q83, Q84],
};

export const allQuestionsList = [
  Q1, Q2, Q3, Q4, Q5, Q6, Q7, Q8, Q9, Q10,
  Q11, Q12, Q13, Q14, Q15, Q16, Q17, Q18, Q19, Q20,
  Q21, Q22, Q23, Q24, Q25, Q26, Q27, Q28, Q29, Q30,
  Q31, Q32, Q33, Q34, Q35, Q36, Q37, Q38, Q39, Q40,
  Q41, Q42, Q43, Q44, Q45, Q46, Q47, Q48, Q49, Q50,
  Q51, Q52, Q53, Q54, Q55, Q56, Q57, Q58, Q59, Q60,
  Q61, Q62, Q63, Q64, Q65, Q66, Q67, Q68, Q69, Q70,
  Q71, Q72, Q73, Q74, Q75, Q76, Q77, Q78, Q79, Q80,
  Q81, Q82, Q83, Q84, Q85, Q86, Q87, Q88, Q89, Q90,
  Q91, Q92, Q93, Q94, Q95, Q96, Q97, Q98, Q99, Q100,
];
